/** @jsx jsx */

import { PropsWithChildren } from 'react';

import { jsx, css } from '@emotion/core';
import { Colors } from '@zapier/design-system';

const Styles = {
  root: css`
    color: ${Colors.GrayWarm7};
    background-color: ${Colors.GrayWarm2};
    padding: 2px;
    white-space: pre;
    border: 1px solid #dadfe2;
    border-radius: 2px;
  `,
};

type Props = PropsWithChildren<{}>;

function Code(props: Props) {
  const { children } = props;

  return <span css={Styles.root}>{children}</span>;
}

export default Code;
